import { render, staticRenderFns } from "./SpTab.vue?vue&type=template&id=4d11d546&scoped=true"
import script from "./SpTab.vue?vue&type=script&lang=ts"
export * from "./SpTab.vue?vue&type=script&lang=ts"
import style0 from "./SpTab.vue?vue&type=style&index=0&id=4d11d546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d11d546",
  null
  
)

export default component.exports